import accordionController from './accordion';
import accordionWithSliderController from './accordionWithSlider';
import addToCartButtonAnimationController from './addToCartButtonAnimation';
import buildYourOwnRechargeBundleController from './buildYourOwnRechargeBundle';
import cartExtraController from './cart-extra';
import detectDeviceController from './detectDevice';
import exploreOurCollectionsController from './exploreOurCollections';
import headerController from './header';
import isScrolledController from './isScroller';
import partnersSliderController from './partnersSlider';
import performancePrefetchLinksController from './performancePrefetchLinksController';
import productAdditionalInformationController from './productAdditionalInformation';
import productMediaSliderController from './productMediaSlider';
import quickAddController from './quickAdd';
import ratingsController from './ratings';
import readMoreButtonsController from './readMoreButtons';
import relatedProductsController from './relatedProducts';
import reviewsController from './reviews';
import scrollToController from './scrollTo';
import sliderForProductPageController from './sliderForProductPage';
import ugcVideosController from './ugcVideos';
import vibeCarouselController from './vibeCarousel';
import jumpToSectionsController from './jumpToSections';
import productPairsWellController from './productPairsWell';
import productController from './product';
import stampedController from './stamped';
import chillStoriesController from './chillStories';
import autoContrastController from './autoContrast';
import itemsInCartController from './itemsInPack';
import collectionSimpleFiltersController from './collectionSimpleFilters';
import liveCartCountController from './liveCartCountController';
import videoReviewsController from './videoReviewsController';
import selectYourStashController from './selectYourStash';
import routeMonsterCartCompat from './routeMonsterCartCompat';

export default function registerControllers() {
  document.addEventListener('DOMContentLoaded', () => {
    headerController();
    cartExtraController();
    performancePrefetchLinksController();
    scrollToController();
    isScrolledController();
    quickAddController();
    detectDeviceController();
    accordionController();

    routeMonsterCartCompat();

    productController();
    ratingsController();

    autoContrastController();
    itemsInCartController();
    liveCartCountController();

    accordionWithSliderController();
    addToCartButtonAnimationController();
    buildYourOwnRechargeBundleController();
    exploreOurCollectionsController();
    partnersSliderController();
    productAdditionalInformationController();
    productMediaSliderController();
    readMoreButtonsController();
    relatedProductsController();
    reviewsController();
    sliderForProductPageController();
    ugcVideosController();
    vibeCarouselController();
    jumpToSectionsController();

    collectionSimpleFiltersController();

    productPairsWellController();

    stampedController();

    chillStoriesController();

    videoReviewsController();

    selectYourStashController();
  });
}
